import type { EnumUnion } from "@dresscode-frontend/utility-types";

/**
 * Certification Holder Status
 */
export const CertificationHolderStatus = {
  ACTIVE: "ACTIVE", // 有効
  APPLYING: "APPLYING", // 申請中
  EXPIRED: "EXPIRED", // 失効
  SUSPENDED: "SUSPENDED", // 停止
  REVOKED: "REVOKED", // 剥奪
} as const;

export type CertificationHolderStatus =
  (typeof CertificationHolderStatus)[keyof typeof CertificationHolderStatus];

/**
 * 取扱資格一覧のソート可能なカラム
 */
export const CertificationHoldersOrderBy = {
  CERTIFICATION_HOLDER: "CERTIFICATION_HOLDER",
  CERTIFICATION_NUMBER: "CERTIFICATION_NUMBER",
  LAST_RENEWAL_DATE: "LAST_RENEWAL_DATE",
  VALID_TO: "VALID_TO",
  RENEWAL_DEADLINE: "RENEWAL_DEADLINE",
} as const satisfies Record<string, string>;

export type CertificationHoldersOrderBy = EnumUnion<
  typeof CertificationHoldersOrderBy
>;

/**
 * テーブルカラムの定義
 */
export const CertificationHolderTableColumns = {
  certificationHolder: "certificationHolder",
  certificationNumber: "certificationNumber",
  lastRenewalDate: "lastRenewalDate",
  validTo: "validTo",
  renewalDeadline: "renewalDeadline",
} as const;

export type CertificationHolderTableColumns =
  (typeof CertificationHolderTableColumns)[keyof typeof CertificationHolderTableColumns];
